import { createUseStyles } from "react-jss";

/**
 * Styles for the user management page
 */
export const useTeamManagementPageStyles = createUseStyles({
  mainContentCls: {
    padding: "2em"
  },
  titleCls: {
    fontSize: "20px",
    fontWeight: "bold"
  }
});
